<div class="accountPage">
  <div class="row accountPageTopFilter">
    <div class="col-md-10 col-lg-11">
      <app-efulfillmentfilter [filters]="filterArray"></app-efulfillmentfilter>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <app-efulfillmenttable [propHeaderDS]="headerList" [propBodyDS]="dataSourceList"></app-efulfillmenttable>
    </div>
  </div>
</div>
